import React from 'react';
import tpl from '../templates/abroad';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;
}
